export const LOGIN_ROUTE = "msq:login";
export const PAY_ROUTE = "msq:pay";
export class MSQICRC35Client {
    connection;
    static Origin = "https://msq.tech";
    constructor(connection) {
        this.connection = connection;
    }
    async login() {
        const result = await this.connection.request(LOGIN_ROUTE, undefined);
        if (typeof result !== "boolean") {
            throw new Error("Got invalid login response from MSQ, expected type 'boolean'");
        }
        return result;
    }
    async pay(req) {
        const result = await this.connection.request(PAY_ROUTE, req);
        if (result !== null && typeof result !== "bigint") {
            throw new Error("Got invalid pay response from MSQ, expected type 'bigint | null'");
        }
        return result;
    }
}
